module.exports = __webpack_public_path__ + "static/four_explain.f55bd434.png";